module.exports = __webpack_public_path__ + "img/22_48.fed86cbe.png";